import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ComercialLayout } from '../../components/comercial/ComercialLayout';
import { DocumentosCliente } from '../../components/comercial/DocumentosCliente';
import { useAuth } from '../../context/AuthContext';
import { ShieldCheck } from 'lucide-react';

export default function DocumentacionPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <ComercialLayout
      title="Documentación"
      subtitle="Centro documental oficial Manklar"
      onLogout={handleLogout}
    >
      <div className="space-y-4" data-testid="documentacion-page">
        <div className="flex items-center gap-3 p-4 rounded-xl bg-white/[0.02] border border-white/[0.06]">
          <ShieldCheck className="w-5 h-5 text-emerald-400 flex-shrink-0" />
          <p className="text-xs text-zinc-500 font-['Manrope']">
            Documentos oficiales con autorrellenado desde la ficha del cliente, firma en pantalla e historial permanente.
            {user?.role === 'comercial' ? ' Tu rol tiene acceso al Acuerdo Manklar.' : ' Acceso completo a las 5 plantillas oficiales.'}
            {' '}Plantillas y cláusulas serán gestionables desde el Portal de Administración.
          </p>
        </div>
        <div className="p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06]">
          <DocumentosCliente showCliente />
        </div>
      </div>
    </ComercialLayout>
  );
}
